import { media } from '../styles/breakpoints';
const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
        <div className="container">
            <h1>Политика конфиденциальности</h1>
                <section> 
                    <h2>1. Общие положения</h2> 
                    <p>Настоящая политика обработки персональных данных составлена в соответствии с требованиями Федерального закона от 27.07.2006. №152-ФЗ «О персональных данных» (далее — Закон о персональных данных) и определяет порядок обработки персональных данных и меры по обеспечению безопасности персональных данных, предпринимаемые Оператором.</p> 
                    <p><strong>1.1.</strong> Пользователь дает свое согласие на обработку его персональных данных, указанных в формах заявок на сайте (имя, номер телефона, адрес электронной почты), путем совершения конклюдентных действий: заполнения полей формы и нажатия кнопок «Отправить», «Оставить заявку», «Заказать звонок» и иных аналогичных. Согласие считается полученным в момент отправки формы.</p> 
                    <p><strong>1.2.</strong> Обработка персональных данных осуществляется в целях связи с Пользователем для ответа на его запрос, консультации, заключения и исполнения договоров, а также для информирования об оказываемых услугах.</p> 
                </section>
                <section> 
                    <h2>2. Основные понятия, используемые в Политике</h2> 
                    <p><strong>Автоматизированная обработка персональных данных</strong> — обработка персональных данных с помощью средств вычислительной техники.</p> 
                    <p><strong>Персональные данные</strong> — любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных). В рамках настоящей Политики к персональным данным Пользователя относятся: </p> 
                    <ul> 
                        <li>Фамилия, имя, отчество (ФИО);</li> 
                        <li>Контактный номер телефона;</li> 
                        <li>Адрес электронной почты (e-mail);</li> 
                        <li>Иная информация, предоставленная Пользователем добровольно путем заполнения форм на Сайте.</li> 
                    </ul> 
                    <p><strong>Оператор</strong> — наша компания ООО WayPay, которая самостоятельно или совместно с другими лицами организует и (или) осуществляет обработку персональных данных.</p> 
                </section>
                <section> 
                    <h2>3. Права субъекта персональных данных</h2> 
                    <p><strong>3.1.</strong> Субъект персональных данных (Пользователь) имеет право:</p> 
                    <ul> 
                        <li>на получение информации, касающейся обработки его персональных данных;</li> 
                        <li>на уточнение, блокирование или уничтожение его персональных данных в случае, если они являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки;</li> 
                        <li>отозвать свое согласие на обработку персональных данных, направив нам соответствующее письменное уведомление по адресу, указанному в разделе «Реквизиты Оператора».</li> 
                        <li>на защиту своих прав и законных интересов, в том числе на возмещение убытков и компенсацию морального вреда в судебном порядке.</li> 
                    </ul> 
                    <p><strong>3.2.</strong> Для реализации своих прав Пользователь может обратиться к Оператору с запросом по контактным данным, указанным на Сайте.</p> 
                </section><section> 
                    <h2>4. Порядок сбора и обработки персональных данных</h2> 
                    <p><strong>4.1.</strong> Мы получаем и обрабатываем персональные данные Пользователя строго в тех объемах и для тех целей, которые были предоставлены Пользователем добровольно при заполнении форм на Сайте.</p> 
                    <p><strong>4.2.</strong> Обработка предоставленных данных (ФИО, телефона, e-mail) осуществляется в целях:</p> 
                    <ul> 
                        <li>Обработки входящих запросов и связи с Пользователем;</li> 
                        <li>Заключения договоров и их исполнения;</li> 
                        <li>Направления Пользователю информации о наших услугах и акциях (только с его согласия, выраженного отдельным действием, например, проставлением галочки в соответствующем поле формы).</li> 
                    </ul> 
                    <p><strong>4.3.</strong> Мы гарантируем конфиденциальность полученной информации. Не допускается передача персональных данных третьим лицам, за исключением случаев, прямо предусмотренных законодательством РФ, или по прямому согласию Пользователя.</p> 
                    <p><strong>4.4.</strong> Все данные передаются по защищенным каналам связи и хранятся в течение срока, необходимого для достижения целей обработки, либо до момента отзыва согласия субъектом персональных данных.</p> 
                </section>
                <section> 
                    <h2>5. Заключительные положения</h2> 
                    <p><strong>5.1.</strong> Настоящая политика является общедоступной. Актуальная версия Политики размещена на Сайте.</p> 
                    <p><strong>5.2.</strong> К настоящей Политике и отношениям между Пользователем и Оператором, возникающим в связи с применением Политики, подлежит применению право Российской Федерации.</p> 
                    <p><strong>5.3.</strong> Все разногласия подлежат разрешению в соответствующем суде по месту нахождения Оператора.</p> 
                    <p><strong>5.4.</strong> Оператор вправе вносить изменения в настоящую Политику. Новая редакция вступает в силу с момента ее размещения на Сайте.</p> 
                </section>
        </div>
      
      <style>{`
        .privacy-policy {
          min-height: 100vh;
          padding: 2rem 0;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          color: #333;
        }
        
        .container {
          max-width: 800px;
          margin: 0 auto;
          background: white;
          padding: 3rem;
          border-radius: 15px;
        }
        
        h1 {
          text-align: center;
          color: #2c3e50;
          margin-bottom: 2.5rem;
          font-size: 2.5rem;
          position: relative;
          padding-bottom: 1rem;
        }
        
        h1:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 100px;
          height: 4px;
          background: linear-gradient(to right, rgba(0, 125, 136, 1), rgba(37, 203, 161, 1));
          border-radius: 2px;
        }
        
        section {
          margin-bottom: 2.5rem;
          padding: 1.5rem;
          border-radius: 8px;
          background: #f8f9fa;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          border-left: 4px solid rgba(0, 125, 136, 1);
        }
        
        section:hover {
          transform: translateY(-3px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        }
        
        h2 {
          color: #2c3e50;
          margin-top: 0;
          margin-bottom: 1rem;
          font-size: 1.5rem;
        }
        
        p {
          line-height: 1.6;
          color: #555;
          margin: 0;
        }
        
        ${media.down('sm')} {
          .container {
            padding: 1.5rem;
            margin: 1rem;
          }
          
          h1 {
            font-size: 2rem;
          }
          
          section {
            padding: 1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default PrivacyPolicy;